import { locationStorage } from '../services'
import { defineNuxtRouteMiddleware, navigateTo } from '#imports'
import { AuthErrorKeys, useAuthService } from '@b2ag/auth'
import { useLogger } from '@b2ag/utils/src/useLogger'
import { cleanForceLoginFromPath } from '../helpers/cleanForceLoginFromPath'

const logger = useLogger()

export default defineNuxtRouteMiddleware(async (to) => {
  if (to.meta.oauthWorkflow) {
    return
  }

  const authService = useAuthService()
  // Attention isAuthenticated() ne vérifie pas l'expiration de l'access token, il check simplement si l'utilisateur
  // fut connecté au front
  if (await authService.isAuthenticated()) {
    // À noter : si l'utilisateur est connecté, on s'attend à ce qu'il se reconnecte même s'il tente d'accéder à une
    // page qui n'est pas privée: car ces pages s'appuient quand même sur la session (segmentation etc), et on estime
    // que l'utilisateur qui était connecté jusqu'ici s'attend à voir la page dans le contexte de sa session et non en
    // mode déconnecté, quite à se reconnecter.
    try {
      await authService.checkUserAuthSession()
      // maintenant l'utilisateur est connecté et authentifié à jour
    } catch (e: any) {
      if (e.message === AuthErrorKeys.IS_NOT_AUTHENTICATED) {
        logger.info('user is not authenticated anymore. Redirecting to login page.')
        if (!to.meta.doNotStoreRoute || to.meta.storePathBeforeAuth) {
          locationStorage.storeLocation(cleanForceLoginFromPath(to.fullPath))
        }

        return navigateTo({ name: 'login' })
      } else if (e.message === AuthErrorKeys.INVALID_SCOPE || e.message.includes('not-allowed')) {
        return navigateTo({ name: 'auth-callback-error', query: { error_code: e.message } })
      } else {
        logger.error('unexpected error while checking user session:')
        logger.error(e)
        return navigateTo({ name: 'auth-callback-error', query: { error_code: e.message } })
      }
    }
  }
})
